import { useContext } from "react";
import { AppContext } from "./AppContext";

const useAppState = () => {
  return useContext(AppContext);
};

export default useAppState;
